const m = require('minthril');
const { component } = require('../../component');
const { Breadcrumbs } = require('../../components/breadcrumbs');

const ContactPage = component(() => ({
  view: () => m('section.panel.contact-page', [
    m(Breadcrumbs, { items: [{ label: 'Contact' }] }),
    m('h2', 'Contact Spache'),
    m('p', 'Questions, feedback, or need a hand? Email us and we’ll get back to you.'),
    m('a', {
      href: 'mailto:info@spache.online?subject=Spache%20enquiry'
    }, 'Email info@spache.online')
  ])
}));

module.exports = { ContactPage };
